import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class AudienceService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/audience');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }
}
